import type { SearchResult } from '../types'
import { ResultRow } from './ResultRow'

interface ResultListProps {
  results: SearchResult[]
  query?: string
  activeIndex?: number
  onResultClick?: (url: string) => void
}

export function ResultList({ results, query, activeIndex = 0, onResultClick }: ResultListProps) {
  if (results.length === 0) return null

  return (
    <div class="spotlight-results" role="listbox">
      {results.map((result, i) => (
        <ResultRow key={result.id} result={result} query={query} isActive={i === activeIndex} onResultClick={onResultClick} />
      ))}
    </div>
  )
}
